import React from 'react';
import { useTranslation } from 'react-i18next';
import { CONTENT_LIMITS, contentLimitMessage } from '../../utils/contentLimits';
import './ContentLimitStatus.scss';

export default function ContentLimitStatus({ measurement, kind = 'comment', id }) {
  const { t, i18n } = useTranslation();
  const language = i18n?.resolvedLanguage || i18n?.language || 'en';
  const error = contentLimitMessage(measurement.error, t);
  return <div id={id} className={`content-limit-status${error ? ' content-limit-status--error' : ''}`}>
    <span aria-label={t('brand:characterCount', { defaultValue: 'Characters' })}>
      {measurement.characters.toLocaleString(language)} / {CONTENT_LIMITS[kind].toLocaleString(language)}
    </span>
    {kind === 'about' && <span className="content-limit-status__lines">
      {t('brand:aboutLineCount', { count: measurement.lines, limit: CONTENT_LIMITS.aboutLines,
        defaultValue: 'Lines: {{count}} / {{limit}}' })}
    </span>}
    {error && <p role="alert">{error}</p>}
  </div>;
}
